var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('back'),_c('div',{staticClass:"about-content"},[_vm._v("Not yet pls I'm still not ready :S")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }